// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__8IaYG","Text":"Intro_Text__V6yat"};